var _excluded = ["label", "price", "periodSelect", "primaryButton", "secondaryButton", "footer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import isNotEmpty from "../../../utils/isNotEmpty";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import PushOrg from "../../organisms/PushOrg";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
var biggerBreakpointValue = "large";
var subContainerPaddingSpaceForBiggerBreakpoint = 3;
var mainBackgroundForBiggerBreakpoint = "backgroundLightToDefault";
var footerBackground = "backgroundLight";
var Container = styled.div.withConfig({
  componentId: "sc-2npcak-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["", "{overflow:hidden;border:", " solid ", ";border-radius:", ";}"], breakpoint(biggerBreakpointValue), unit(1), getBorderColor(theme, $onColor, "low"), getBorderRadius(theme, "medium"));
});
var Main = styled.div.withConfig({
  componentId: "sc-2npcak-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  var _theme$colors$mainBac = theme.colors[mainBackgroundForBiggerBreakpoint],
    color = _theme$colors$mainBac.color,
    toColor = _theme$colors$mainBac.toColor;
  return css(["", "{padding:", ";background-image:linear-gradient(", ",", ");}"], breakpoint(biggerBreakpointValue), space(subContainerPaddingSpaceForBiggerBreakpoint), color, toColor);
});
var LabelContainer = styled.div.withConfig({
  componentId: "sc-2npcak-2"
})(["display:flex;justify-content:flex-end;margin-bottom:", ";"], space(1));
var Buttons = styled.div.withConfig({
  componentId: "sc-2npcak-3"
})(["margin-top:", ";> *{margin-bottom:", ";&:last-child{margin-bottom:0;}}"], space(2), space(1));
var Footer = styled.div.withConfig({
  componentId: "sc-2npcak-4"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["", "{padding:", ";background:", ";}"], breakpoint(biggerBreakpointValue), space(subContainerPaddingSpaceForBiggerBreakpoint), getColor(theme, footerBackground));
});
function ProductSummaryMol(_ref4) {
  var label = _ref4.label,
    price = _ref4.price,
    periodSelect = _ref4.periodSelect,
    primaryButton = _ref4.primaryButton,
    secondaryButton = _ref4.secondaryButton,
    footer = _ref4.footer,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var onColor = useContext(OnColorContext);
  var isBiggerBreakpoint = useBreakpoint(biggerBreakpointValue);
  return /*#__PURE__*/React.createElement(Container, _extends({
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(Main, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: isBiggerBreakpoint ? mainBackgroundForBiggerBreakpoint : onColor
  }, isNotEmpty(label) ? /*#__PURE__*/React.createElement(LabelContainer, null, label) : undefined, price, periodSelect ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 2,
    bottomSpace: -1
  }, periodSelect) : null, /*#__PURE__*/React.createElement(Buttons, null, primaryButton, secondaryButton))), isBiggerBreakpoint && footer ? /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: footerBackground
  }, footer)) : null);
}
ProductSummaryMol.PrimaryButton = PrimaryButton;
ProductSummaryMol.SecondaryButton = SecondaryButton;
export default ProductSummaryMol;